export default /* css */ `
:host {
  --ui-button-label-font: var(--ui-sys-typescale-label-large-font-family-name);
  --ui-button-label-color: var(--ui-sys-color-primary);
  --ui-button-label-size: var(--ui-sys-typescale-label-large-font-size);
  --ui-button-label-weight: var(--ui-sys-typescale-label-large-font-weight);
  --ui-button-label-line-height: var(
    --ui-sys-typescale-label-large-line-height
  );
  --ui-button-label-tracking: var(
    --ui-sys-typescale-label-large-letter-spacing
  );
  --ui-button-label-opacity: 1;
  --ui-button-label-disabled-opacity: 1;
  --ui-button-label-disabled-color: var(--ui-sys-color-on-surface);

  --ui-button-container-height: calc(var(--ui-sys-unit) * 40);
  --ui-button-container-width: auto;
  --ui-button-container-shape: var(--ui-sys-shape-corner-full);
  --ui-button-container-color: transparent;
  --ui-button-container-padding-left: calc(var(--ui-sys-unit) * 24);
  --ui-button-container-padding-right: calc(var(--ui-sys-unit) * 24);
  --ui-button-container-padding-top: 0;
  --ui-button-container-padding-bottom: 0;
  --ui-button-container-disabled-opacity: 1;
  --ui-button-container-opacity: 1;

  --ui-button-icon-left-margin: calc(var(--ui-sys-unit) * 8);
  --ui-button-icon-size: calc(var(--ui-sys-unit) * 18);
  --ui-button-icon-disabled-opacity: 1;
  --ui-button-icon-color: var(--ui-sys-color-primary);
  --ui-button-icon-opacity: 1;
  --ui-button-icon-disabled-color: var(--ui-sys-color-on-surface);

  --ui-button-pressed-state-layer-color: var(--ui-sys-color-primary);
  --ui-button-pressed-state-layer-opacity: var(
    --ui-sys-state-pressed-state-layer-opacity
  );

  --ui-button-outline-color: var(--ui-sys-color-outline);
  --ui-button-oultine-opacity: 1;
  --ui-button-outline-disabled-color: var(--ui-sys-color-on-surface);
  --ui-button-oultine-disabled-opacity: 0.12;
  --ui-button-outline-width: 0;
}

.ui-button {
  cursor: pointer;
  font-size: var(--ui-button-label-size);
  border-radius: var(--ui-button-container-shape);
  background-color: hsl(
    var(--ui-button-container-color),
    var(--ui-button-container-opacity)
  );
  border: var(--ui-button-outline-width) solid
    hsl(var(--ui-button-outline-color), var(--ui-button-oultine-opacity));
  font-family: var(--ui-button-label-font);
  padding-top: var(--ui-button-container-padding-top);
  padding-bottom: var(--ui-button-container-padding-bottom);
  padding-left: var(--ui-button-container-padding-left);
  padding-right: var(--ui-button-container-padding-right);
  font-weight: var(--ui-button-label-weight);
  line-height: var(--ui-button-label-line-height);
  letter-spacing: var(--ui-button-label-tracking);
  color: hsl(var(--ui-button-label-color), var(--ui-button-label-opacity));
  transition: 200ms;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  position: relative;
  z-index: 0;
  width: var(--ui-button-container-width);
  min-width: var(--ui-button-container-width);
  height: var(--ui-button-container-height);
  min-height: var(--ui-button-container-height);

  &:focus,
  &:hover {
    outline: none;
  }

  &.ui-button--has-start-icon {
    --ui-button-container-padding-left: calc(var(--ui-sys-unit) * 16);
  }

  &.ui-sys-state-layer:before {
    transition-timing-function: cubic-bezier(
      var(--ui-sys-motion-easing-standard)
    );
    transition-duration: var(--ui-sys-motion-duration-short4);
    transition-property: background-color;
  }

  .ui-icon {
    --ui-icon-color: var(--ui-button-icon-color);
    --ui-icon-opacity: var(--ui-button-icon-opacity);
    --ui-icon-size: var(--ui-button-icon-size);
  }

  .ui-button-content__start-icon,
  .ui-button-content__end-icon {
    font-size: var(--ui-button-icon-size);
    display: flex;
  }
}

.ui-button-content {
  display: flex;
  align-items: center;
  width: 100%;

  > *:not(:first-child) {
    margin-left: var(--ui-button-icon-left-margin);
  }

  .ui-button-content__body {
    display: inherit;
    align-items: inherit;
    width: inherit;
    justify-content: inherit;
  }
}

.ui-button--variant-filled {
  --ui-button-container-color: var(--ui-sys-color-primary);
  --ui-button-label-color: var(--ui-sys-color-on-primary);
  --ui-button-icon-color: var(--ui-sys-color-on-primary);

  border: none;

  &:hover {
    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level1-shadow);
    }
  }

  &.ui-button--is-pressed {
    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
    }
  }

  &.ui-button--is-disabled {
    --ui-button-container-color: var(--ui-sys-color-on-surface);
    --ui-button-container-disabled-opacity: 0.12;
    --ui-button-label-disabled-opacity: 0.38;
    --ui-button-label-disabled-color: var(--ui-sys-color-on-surface);
    --ui-button-icon-disabled-color: var(--ui-sys-color-on-surface);

    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
    }
  }

  ui-ripple {
    --ui-ripple-pressed-color: var(--ui-sys-color-on-primary);
    --ui-ripple-hover-color: var(--ui-sys-color-on-surface);
  }
}

.ui-button--variant-tonal {
  --ui-button-container-color: var(--ui-sys-color-secondary-container);
  --ui-button-icon-color: var(--ui-sys-color-on-secondary-container);

  &:hover {
    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level1-shadow);
    }
  }

  &.ui-button--is-pressed {
    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
    }
  }

  &.ui-button--is-disabled {
    --ui-button-container-color: var(--ui-sys-color-on-surface);
    --ui-button-container-disabled-opacity: 0.12;
    --ui-button-label-disabled-opacity: 0.38;
    --ui-button-label-disabled-color: var(--ui-sys-color-on-surface);
    --ui-button-icon-disabled-color: var(--ui-sys-color-on-surface);

    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
    }
  }

  .ui-ripple {
    --ui-ripple-pressed-color: var(--ui-sys-color-on-secondary-container);
    --ui-ripple-hover-color: var(--ui-sys-color-on-secondary-container);
  }
}

.ui-button--variant-elevated {
  --ui-button-container-color: var(--ui-sys-color-surface-container-low);

  &.ui-sys-elevation-layer:after {
    --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level1-shadow);
  }

  &:focus,
  &:hover {
    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level2-shadow);
    }
  }

  &.ui-button--is-disabled {
    --ui-button-container-color: var(--ui-sys-color-on-surface);
    --ui-button-container-disabled-opacity: 0.12;
    --ui-button-label-disabled-opacity: 0.38;
    --ui-button-label-disabled-color: var(--ui-sys-color-on-surface);
    --ui-button-icon-disabled-color: var(--ui-sys-color-on-surface);

    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
    }
  }

  &.ui-button--is-pressed {
    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level1-shadow);
    }
  }

  ui-ripple {
    --ui-ripple-pressed-color: var(--ui-button-pressed-state-layer-color);
    --ui-ripple-pressed-opacity: var(--ui-button-pressed-state-layer-opacity);
  }
}

.ui-button--variant-outlined {
  --ui-button-outline-width: calc(var(--ui-sys-unit) * 1);

  &.ui-button--is-disabled {
    --ui-button-container-color: var(--ui-sys-color-on-surface);
    --ui-button-container-disabled-opacity: 0.12;
    --ui-button-label-disabled-opacity: 0.38;
    --ui-button-label-disabled-color: var(--ui-sys-color-on-surface);
    --ui-button-icon-disabled-color: var(--ui-sys-color-on-surface);

    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
    }
  }

  ui-ripple {
    --ui-ripple-pressed-color: var(--ui-sys-color-primary);
  }
}

.ui-button--variant-text {
  &.ui-button--is-disabled {
    --ui-button-container-disabled-opacity: 0.12;
    --ui-button-label-disabled-opacity: 0.38;
    --ui-button-label-disabled-color: var(--ui-sys-color-on-surface);
    --ui-button-icon-disabled-color: var(--ui-sys-color-on-surface);

    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
    }
  }

  ui-ripple {
    --ui-ripple-pressed-color: var(--ui-sys-color-primary);
    --ui-ripple-hover-color: var(--ui-sys-color-on-surface);
  }
}

.ui-button--is-disabled {
  --ui-button-container-color: var(--ui-button-container-disabled-color);
  --ui-button-container-opacity: var(--ui-button-container-disabled-opacity);
  --ui-button-label-color: var(--ui-button-label-disabled-color);
  --ui-button-icon-color: var(--ui-button-icon-disabled-color);
  --ui-button-icon-opacity: var(--ui-button-icon-disabled-opacity);
  --ui-button-label-opacity: var(--ui-button-label-disabled-opacity);
  --ui-button-outline-color: var(--ui-button-oultine-disabled-color);
  --ui-button-outline-opacity: var(--ui-button-oultine-disabled-opacity);

  cursor: unset;
}
`;
